import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {

  get applicationName(): string {
    const permissions = localStorage.getItem('permissions');
    const hostname = window && window.location
      ? window.location.hostname.toLowerCase()
      : '';
    return permissions === 'Manufacturer' ||
      hostname === 'cut-turomas.vidrioservice.com' ||
      hostname.indexOf('cut-turomas.') === 0
      ? 'VS-Cut oem'
      : 'VS-Cut';
  }

  constructor() { }

  ngOnInit() {
  }

}
